import FetchWrapper from '../../shared/utils/FetchWrapper';
import { API_BASE_URL, API_ENDPOINTS } from '../../shared/constants/api';

class AuthService {
  constructor() {
    this.api = new FetchWrapper(API_BASE_URL);
  }

  async loginWithGoogle(googleToken) {
    try {
      // Para login no necesitamos headers de auth
      const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.AUTH.GOOGLE}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ token: googleToken })
      });

      if (!response.ok) {
        let errorMessage = 'Error de autenticación';
        
        try {
          const errorData = await response.json();
          
          // Manejo específico por código de estado
          switch (response.status) {
            case 400:
              errorMessage = 'Error en la autenticación con Google. Contacta al soporte';
              break;
            case 401:
              errorMessage = 'Usuario no autorizado para acceder al sistema';
              break;
            case 403:
              errorMessage = 'Acceso denegado. Contacta al administrador';
              break;
            case 404:
              errorMessage = 'Servicio de autenticación no disponible';
              break;
            case 500:
              errorMessage = 'Error interno del servidor. Intenta más tarde';
              break;
            default:
              errorMessage = errorData.detail || errorData.message || 'Error de autenticación';
          }
        } catch (parseError) {
          // Si no se puede parsear la respuesta, usar mensaje genérico
          errorMessage = `Error de conexión (${response.status})`;
        }
        
        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('Login error:', error);
      
      // Si es un error de red (fetch failed)
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        throw new Error('No se pudo conectar al servidor. Verifica tu conexión a internet');
      }
      
      // Si ya es un error personalizado, mantenerlo
      throw error;
    }
  }

  async logout() {
    try {
      await this.api.post(API_ENDPOINTS.AUTH.LOGOUT);
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      this.clearAuthData();
    }
  }

  saveAuthData(userData, token) {
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
  }

  clearAuthData() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }

  getStoredUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  getStoredToken() {
    return localStorage.getItem('token');
  }

  isAuthenticated() {
    return !!this.getStoredToken();
  }
}

export default new AuthService();